export default __webpack_public_path__ + "static/media/aurum-devicesImage.27126372.svg";